import { FETCH_PENDING_INVENTORY_LIST, FETCH_PENDING_INVENTORY_DETAIL } from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  pendingInventoryList: {
    inventories: [],
    hasMore: false,
    error: null,
    loading: false,
  },
  pendingInventoryDetail: {
    detail: undefined,
    error: null,
    loading: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_PENDING_INVENTORY_LIST
    // --------------------------------------------------------------------------
    case FETCH_PENDING_INVENTORY_LIST.init:
      return {
        ...state,
        pendingInventoryList: { ...state.pendingInventoryList, hasMore: false, error: null, loading: true },
      };
    case FETCH_PENDING_INVENTORY_LIST.success:
      return {
        ...state,
        pendingInventoryList: {
          ...state.pendingInventoryList,
          inventories: action.payload.results,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_PENDING_INVENTORY_LIST.failure:
      return {
        ...state,
        pendingInventoryList: {
          ...state.pendingInventoryList,
          inventories: [],
          pages: 1,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_PENDING_INVENTORY_DETAIL
    // --------------------------------------------------------------------------
    case FETCH_PENDING_INVENTORY_DETAIL.init:
      return {
        ...state,
        pendingInventoryDetail: { ...state.pendingInventoryDetail, detail: null, error: null, loading: true },
      };
    case FETCH_PENDING_INVENTORY_DETAIL.success:
      return {
        ...state,
        pendingInventoryDetail: { ...state.pendingInventoryDetail, detail: action.payload, error: null, loading: false },
      };
    case FETCH_PENDING_INVENTORY_DETAIL.failure:
      return {
        ...state,
        pendingInventoryDetail: {
          ...state.pendingInventoryDetail,
          detail: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
